/**
 * @generated SignedSource<<da2d00f51cec166ddb83cf004f9dac5a>>
 * @relayHash d0658dbfa9ca69782715f7b561c52822
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 872b5df71eb3e195d8fd8a0b578dc7e87affe68fe0468ad3c7f6dfd097214bf9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery } from './uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "872b5df71eb3e195d8fd8a0b578dc7e87affe68fe0468ad3c7f6dfd097214bf9",
    "metadata": {},
    "name": "uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
